// @flow strict

import * as React from 'react'
import { type PropsWithChildren } from '@mondough/public-web-components'
import FeatureDiscoveryGrid, { type Feature } from '../FeatureDiscoveryGrid'
import { SectionWrapper, SectionThemes } from '../../SectionWrapper'

import styles from './BusinessFeatureDiscoveryGrid.module.scss'

type Props = {
  features?: Feature[],
}

const BusinessFeatureDiscoveryGrid = ({
  features,
  children,
}: PropsWithChildren<Props>) =>
  features != null ? (
    <SectionWrapper
      theme={SectionThemes.GREY}
      contentClassName={styles.featureDiscovery}
    >
      {children}
      <FeatureDiscoveryGrid features={features} />
    </SectionWrapper>
  ) : null

export default BusinessFeatureDiscoveryGrid
